module.exports = __webpack_public_path__ + "static/media/smoke_isolated.cb16c9dd.png";